import { render, staticRenderFns } from "./VisDialog.vue?vue&type=template&id=c4f29a64&"
import script from "./VisDialog.vue?vue&type=script&lang=js&"
export * from "./VisDialog.vue?vue&type=script&lang=js&"
import style0 from "./VisDialog.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
